<template>
    <div>
        <g-table-sync
            :app="app"
            :view="view"
            :columns="columns"
            :default-limit="10000"
            :required-filters="routeFilter"
            hideDelete
            hideSearch
            class="provider-report-table"
        >
            <template v-slot:head-right="{ data }">
                <small> <strong> Importe Total: </strong> </small>
                <strong>{{ formatCurrency(getTotal(data)) }} </strong>
            </template>
            <template slot="total" slot-scope="{ item }">
                <span v-if="item.total"> {{ formatCurrency(item.total) }}</span>
            </template>
            <template slot="status" slot-scope="{ item }">
                <g-select
                    :item="item._EntityId"
                    :app="app"
                    name="status"
                    :colors="[$colors.blue, $colors.orange, $colors.success]"
                    block
                />
            </template>
            <template slot="factura" slot-scope="{ item }">
                <g-upload
                    accept=".pdf"
                    name="pdf"
                    app="expenses"
                    :item="item._EntityId"
                    :file-name="'factura_asociada_' + item._EntityId + '.pdf'"
                    folder-name="facturas_gastos"
                    :value="item.pdf"
                />
            </template>
        </g-table-sync>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    name: 'ProviderTable',
    props: {
        provider: {
            type: String,
            required: true,
        },
        date: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            app: 'expenses',
            view: 'providerExpenseList',
            columns: [
                {
                    title: 'Serie',
                    index: 'serie',
                    order: true,
                    search: true,
                },
                {
                    title: 'Importe',
                    index: 'total',
                    order: true,
                    slot: 'total',
                },
                {
                    title: 'Estado',
                    index: 'status',
                    slot: 'status',
                    order: true,
                },
                {
                    title: 'Factura',
                    slot: 'factura',
                },
            ],
        }
    },
    computed: {
        routeFilter() {
            const date_from = this.date[0].format('YYYY-MM-DD')
            const date_to = this.date[1].format('YYYY-MM-DD')
            // const date_to = moment(this.date).endOf('month').format('YYYY-MM-DD')
            return [
                {
                    _ParentOperator: 'AND',
                    _Operator: 'AND',
                    Fields: {
                        provider: {
                            type: 'number',
                            int: Number(this.provider),
                            opt: '=',
                        },
                        invoice_date: {
                            type: 'date',
                            from: date_from,
                            to: date_to,
                        },
                    },
                },
            ]
        },
    },
    methods: {
        formatCurrency(value, fractions = 2) {
            const fixedValue = Number(value).toFixed(fractions)
            const formatter = new Intl.NumberFormat('es-ES', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: fractions,
                maximumFractionDigits: fractions,
            })
            return formatter.format(fixedValue)
        },
        getTotal(data) {
            if (!data.results.length) {
                return 0
            }
            return data.results.reduce((acc, cvv) => acc + cvv.total, 0)
        },
    },
}
</script>

<style lang="scss" module>
.table {
    tr td:first-child {
        min-width: 120px;
    }

    tr td:last-child {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
}

.dropdown button:first-child {
    background: transparent;
    color: white;
}

.dropdown button:last-child {
    background: rgba(255, 255, 255, 0.4);
    color: white;
}

.dropdown.dropdown-primary {
    button,
    button:hover,
    button:focus {
        border-color: $primary;
    }

    button,
    button:hover,
    button:focus {
        background: $primary;
        color: white;
    }
}

.dropdown.dropdown-warning {
    button,
    button:hover,
    button:focus {
        border-color: $warning;
    }

    button,
    button:hover,
    button:focus {
        background: $warning;
        color: white;
    }
}

.dropdown.dropdown-danger {
    button,
    button:hover,
    button:focus {
        border-color: $danger;
    }

    button,
    button:hover,
    button:focus {
        background: $danger;
        color: white;
    }
}

.table tbody tr:nth-of-type(odd) {
    background: #fff !important;
}

.table tbody tr:nth-of-type(even) {
    background: #f2f4f8 !important;
}

.badgeGroup {
    text-transform: uppercase;
    font-weight: bold;
}
</style>

<style lang="scss">
.provider-report-table {
    .card-body {
        .table-responsive {
            table {
                position: relative;
                display: flex;
                flex-direction: column;
                thead {
                    display: flex;
                    flex-direction: column;
                    position: sticky;
                    top: 0;
                    z-index: 1;
                    background: $white;
                }
                tbody {
                    display: flex;
                    flex-direction: column;
                    max-height: 18rem;
                    height: 100%;
                }
                tr {
                    display: grid;
                    grid-template-columns: auto repeat(4, 1fr);
                }
            }
        }
    }
}
</style>
